import {dispatch} from '@wordpress/data';
import {useEffect} from '@wordpress/element';



/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {

	/**
	 * [_dispatchEventCountry description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	function _dispatchEventCountry(e) {
		const eventCountry = e.target.value;
		jQuery('#form_events_field_country').val(eventCountry);
	} 

	let terms = [];
    

	if (props.terms) {
		terms = Object.entries(props.terms).map(([id, value]) => {					                		
				var country_current = jQuery('#form_events_field_country').val(); 
				if (id == country_current) { 
					return <option value={id} selected="selected">{value}</option>
				}
				return <option value={id}>{value}</option>
			}
		)
	}
 
	return (				
		<div className="form-field">
            <select onChange={(e) => _dispatchEventCountry(e)}>
                <option value="0">All</option>
                {terms}
            </select>
		</div>
	);

}